import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdcContract } from "../../utils/contractHelpers";
import { useWeb3React } from "../useWagmiCompat";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const AllowanceUsdc = () => {
  // const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.presaleContract;
  const tokenAddress1 = Environment.usdc;
  const contract = usdcContract(tokenAddress1, web3);

  const allowanceUsdc = useCallback(async () => {
    // console.log(tokenAddress,account,'noor');
    try {
      const buy = await contract.methods
        .allowance(account, tokenAddress)
        .call();
      // console.log('sdsdss' ,  buy)
      return buy / 10 ** 6;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { allowanceUsdc: allowanceUsdc };
};
export default AllowanceUsdc;
